import { Card, CardMedia } from "@material-ui/core";
import clsx from "clsx";
import { useState, useEffect } from "react";
import { Link as LinkRouter } from "react-router-dom";

import { presetImagesService } from "@/api/services/implementations/presetImages";
import ImageNotAvailable from "@/assets/img/ImageNotAvailable.svg";
import { useStyles } from "@/common/components/MapLandingPage/RightUnitDrawer/CameraPreviewStyles";


interface CameraPreviewProps {
    cameraId: number;
    cameraName: string | null;
    className: string;
    presetId: number | null;
}

const CameraPreview: React.FC<CameraPreviewProps> = ({ cameraId, cameraName, className, presetId }) => {
    const classes = useStyles();

    const [presignedUrl, setPresignedUrl] = useState<string>("");

    if (presetId) {
        useEffect(() => {
            presetImagesService
                .fetchPresetImagePresignedUrl(presetId!)
                .then((response) => {
                    setPresignedUrl(response.toString());
                })
                .catch((err) => console.log("PRESIGNED URL ERROR: ", err));
        }, [cameraId]);
    } else {
        console.log("PRESET ID", presetId);
    }

    return (
        <Card className={clsx(classes.root, className)}>
            <LinkRouter to={`/camera/${cameraId}/stream`}>
                <CardMedia
                    component="img"
                    className={classes.media}
                    src={presignedUrl ?? ImageNotAvailable}
                    onError={(e: any) => {
                        //Because even if presets are available they dont give the img
                        e.target.src = ImageNotAvailable;
                    }}
                />
                <div className={classes.cameraDiv}>
                    <span className={classes.cameraName} color="primary">
                        {cameraName}
                    </span>
                </div>
            </LinkRouter>
        </Card>
    );
};

export default CameraPreview;
